/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Item/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ChoiceToggle from 'DesignSystem/ChoiceToggle/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Item({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/MultipleChoice/Options/Item"
  
}) {
let questionTextTransformValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'textTransform',
})
let questionOptionIdValueData = fromData.useDataValue({ viewPath,
context: 'question_option',
path: 'id',
})
let questionAnswerValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer',
})
let aggregateData = fromHelpers.isSelected(questionOptionIdValueData, questionAnswerValueData)
let widgetQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'questions',
})
let questionOptionTextValueData = fromData.useDataValue({ viewPath,
context: 'question_option',
path: 'text',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let aggregateData1 = fromHelpers.populateTemplate(widgetQuestionsValueData, questionOptionTextValueData, selectedAnswersValueData)
let questionOptionIdValueData1 = fromData.useDataValue({ viewPath,
context: 'question_option',
path: 'id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtChoiceBackgroundcolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.backgroundColor.brand.base'
        })
let dtChoiceBackgroundcolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.backgroundColor.brand.hovered'
        })
let dtChoiceBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.backgroundColor.brand.selected'
        })
let dtChoiceBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.borderColor.brand.hovered'
        })
let dtChoiceBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.borderColor.brand.selected'
        })
let dtChoiceColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.color.brand.hovered'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ChoiceToggle
  viewPath={`${viewPath}/ChoiceToggle`}
 width="100%"
 marginTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingTop={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 alignSelf="left"
 fontSize={dtTypographyFontsizeM}
 backgroundColor={dtChoiceBackgroundcolorBrandBase}
 backgroundColorHovered={dtChoiceBackgroundcolorBrandHovered}
 backgroundColorSelected={dtChoiceBackgroundcolorBrandSelected}
 borderColorHovered={dtChoiceBordercolorBrandHovered}
 borderColorSelected={dtChoiceBordercolorBrandSelected}
 colorHovered={dtChoiceColorBrandHovered}
 colorSelected="white"
 data="question.textTransform"
 textTransform={questionTextTransformValueData}
 onClick={onClick}
 data="question_option.id"
 data="question.answer"
 aggregate="helpers.js isSelected"
 isSelected={aggregateData}
 data="widget.questions"
 data="question_option.text"
 data="selected.answers"
 aggregate="helpers.js populateTemplate"
 text={aggregateData1}
 data="question_option.id"
 id={questionOptionIdValueData1}
/>
{children}
</React.Fragment>)
}